import styled from "styled-components";

export const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin: 10px;
  user-select: none;
`;

export const Options = styled.div`
  position: absolute;
  background: #2d2f32;
  border-radius: 0.25rem;
  padding-top: ${({ actived }) => (actived ? "0.48rem" : "0")};
  padding-bottom: ${({ actived }) => (actived ? "0.48rem" : "0")};
  width: 9.14rem;
  margin-top: 1.9rem;
  padding: 1rem
  max-height: ${({ actived }) => (actived ? "auto" : "0")};

  transition: max-height 0.2s ease-in-out, padding-top 0.3s linear,
    padding-bottom 0.2s linear;
`;

export const Option = styled.div`
  background: #2d2f32;
  height: ${({ actived }) => (actived ? "1.764166667rem" : "0")};
  color: #eff1f5;
  font-size: 0.705833333rem;
  display: flex;
  align-items: center;
  padding-left: 0.882rem;
  cursor: pointer;
  transition: height 0.4s ease-in-out;

  &:hover {
    background: #212326;
  }
`;

export const StyledSpan = styled.div`
  opacity: ${({ actived }) => (actived ? "1" : "0")};
  transition: opacity 0.2s ease-in-out;
`;
